import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgIntegrityIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M23.237 17.615a3.484 3.484 0 0 0-2.407-3.305l-2.671-.887A4.026 4.026 0 0 0 15.992 6c-4.017 0-5.518 5.31-2.166 7.423l-2.705.899a3.47 3.47 0 0 0-2.375 3.293v1.522c-.05.623.713 1.65 1.305.982a.536.536 0 0 0-.114-.75.286.286 0 0 1-.12-.232v-1.522a2.4 2.4 0 0 1 1.643-2.277l3.179-1.056a4.226 4.226 0 0 1 2.708 0l3.176 1.056a2.4 2.4 0 0 1 1.643 2.277v1.522a.261.261 0 0 1-.102.216.536.536 0 0 0-.116.749c.583.662 1.342-.33 1.29-.965v-1.522ZM13.033 10.03c.125-3.91 5.794-3.91 5.918 0-.124 3.91-5.794 3.909-5.918 0Zm15.977 3.986-1.984-.66a3.356 3.356 0 1 0-3.96 0 .538.538 0 0 0-.372.67.536.536 0 0 0 .675.358l.611-.203c1.35-.571 3.397.483 4.69.85a1.846 1.846 0 0 1 1.259 1.749v1.226a.143.143 0 0 1-.14.14h-4.945a.536.536 0 0 0 0 1.071h4.945A1.212 1.212 0 0 0 31 18.007V16.78a2.917 2.917 0 0 0-1.99-2.764Zm-3.965-1.079a2.287 2.287 0 0 1 0-4.574 2.287 2.287 0 0 1 0 4.574ZM9.298 14.04a.537.537 0 0 0-.362-.684 3.36 3.36 0 1 0-3.962.001l-1.987.66A2.916 2.916 0 0 0 1 16.78v1.226a1.212 1.212 0 0 0 1.21 1.211h4.93a.536.536 0 0 0 0-1.071H2.21a.143.143 0 0 1-.139-.14V16.78a1.844 1.844 0 0 1 1.257-1.747c1.314-.37 3.302-1.422 4.693-.852l.6.199a.534.534 0 0 0 .677-.341Zm-2.343-1.102a2.287 2.287 0 0 1 0-4.574 2.287 2.287 0 0 1 0 4.574Zm13.642 5.09c-.378-.243-1.39-1.157-1.637-1.093h-5.92a.535.535 0 0 0-.321.107l-1.316.988a.537.537 0 0 0-.214.4c-.157 2.89 1.548 6.845 4.335 8.124.208.097.472.244.7.116 2.953-1.194 4.744-5.254 4.588-8.214a.537.537 0 0 0-.215-.429Zm-4.57 7.553c-2.32-.944-3.8-4.392-3.776-6.848l.968-.726h5.562l.968.724c.03 2.468-1.44 5.803-3.721 6.85Zm1.877-4.537-2.41 1.608a.533.533 0 0 1-.297.09c-.329.048-.849-.674-1.183-.961a.535.535 0 1 1 .758-.758l.493.493 2.045-1.363a.536.536 0 0 1 .594.891Z"
    />
  </svg>
);
export default SvgIntegrityIcon;
